import classNames from "classnames"

import { useCurrentStatus } from "app/AppRouter/CurrentStatusContext"
import { Lang } from "utils/interfaces"
import { SupportDescription } from "components/SupportDescription"
import { getParameterFromUrl } from "utils/helpers"
import {
    isHRAccountPage,
    isListPage,
    isSearchPage,
    isSurveyResultsPage,
    isVideoLobbyPage,
} from "app/AppRouter/utils"
import { Img } from "ui-kit/components-branded/index"
import { Tooltip } from "components/Tooltip"
import { SocialNetworksLinks } from "components/Footer/components/SocialNetworksLinks"
import { PAYMENT_DONE_PARAMETER } from "modules/BookingCommon/common/constants"
import { APP_PAGE_URL } from "utils/env-management"
import { APP_STATUSES } from "utils/AppStatusContext"

const FROM_YEAR = 2017

interface FooterProps {
    showSocialNetworksLinks: boolean
    lang: Lang
    className?: string
}

export function Footer({ showSocialNetworksLinks, lang, className }: FooterProps) {
    const currentStatus = useCurrentStatus()
    const urlIncludesPaymentDoneParameter = getParameterFromUrl(PAYMENT_DONE_PARAMETER) === "1"
    const inProfile = currentStatus === APP_STATUSES.profile
    const inBooking = currentStatus === APP_STATUSES.booking
    const inVideo = isVideoLobbyPage()

    const footerStyles = classNames("alter-footer", className, {
        footer__default: !inBooking && !inVideo,
        "footer__in-booking": inBooking,
        "footer__fixed-button-profile": inProfile,
        "footer__fixed-button-booking": inBooking && !urlIncludesPaymentDoneParameter,
    })

    const text = lang === "ru" ? "Служба поддержки" : "Support"
    const textShorter = lang === "ru" ? "Поддержка" : "Support"

    return (
        <div className={footerStyles}>
            <div className="footer__left">
                <div className="footer__exist-since">
                    <Img src="green-heart-emoji.png" alt="Alter" className="footer__emoji" />
                    Alter, {FROM_YEAR}–{new Date().getFullYear()}
                </div>
                {showSocialNetworksLinks && <SocialNetworksLinks />}
            </div>
            <div className="footer__right">
                {(isSurveyResultsPage() || isSearchPage() || isListPage()) && (
                    <div className="footer-recommend-tech">
                        Применяются&nbsp;
                        <a href={`${APP_PAGE_URL}/recommend`} target="_blank" rel="noreferrer">
                            рекомендательные технологии
                        </a>
                    </div>
                )}
                {!isHRAccountPage() && (
                    <div className="footer-support">
                        <Tooltip placement="top" overlay={<SupportDescription lang="ru" />}>
                            <span className="footer-support__content">
                                <div className="footer-support__text">{text}</div>
                                <div className="footer-support__text-shorter">{textShorter}</div>
                            </span>
                        </Tooltip>
                    </div>
                )}
                {showSocialNetworksLinks && (
                    <div className="footer__social-networks--hide">
                        <SocialNetworksLinks />
                    </div>
                )}
            </div>
        </div>
    )
}

Footer.defaultProps = {
    showSocialNetworksLinks: true,
    lang: "ru",
}
